import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductInfoContainerWrapper = styled.main.withConfig({
  displayName: "ProductInfoContainer__ProductInfoContainerWrapper",
  componentId: "vx4xbw-0"
})(({
  theme,
  $spaceCssStyles,
  flexDirection,
  alignItems
}) => {
  return Object.assign({
    display: 'flex',
    flexDirection,
    alignItems,
    marginBlock: theme.space['0'],
    paddingInline: theme.space['400'],
    maxWidth: '1130px',
    width: '100%',
    [trellisBreakpoint.tabletPortrait]: {
      paddingBlockStart: theme.space['500'],
      paddingInline: 0
    }
  }, $spaceCssStyles);
});
export const ProductInfoContainer = _ref => {
  let {
      children
    } = _ref,
    spaceProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterTokenProps(spaceProps);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(ProductInfoContainerWrapper, {
    role: "main",
    $spaceCssStyles: spaceCssStyles,
    flexDirection: "column",
    alignItems: "center",
    children: children
  });
};
export default ProductInfoContainer;